import themes from '@8x8/oxygen-theme'
import { THEMES } from '../constants'
import common from './common'

export default {
  ...common,
  _name: THEMES.LIGHT,
  _neo: themes.light,
  background: 'white',
  backgroundActiveMeetingOverlay: 'linear-gradient(270deg, #246FE5 43.13%, rgba(36, 111, 229, 0) 95%)',
  backgroundCopyInfo: '#daebfa',
  backgroundEventOverlay: 'linear-gradient(270deg, #E0E0E0 43.13%, rgba(224, 224, 224, 0) 95%)',
  backgroundHighlightedEventOverlay: 'linear-gradient(270deg, #292929 43.13%, rgba(41, 41, 41, 0) 95%)',
  backgroundInput: 'transparent',
  backgroundJoinOptionHint: 'rgba(241, 173, 51, 0.4)',
  backgroundListItemSelected: '#daebfa',
  backgroundModal: 'white',
  backgroundSalesforce: '#F0F3F7',
  backgroundSecondary: '#F0F3F7',
  backgroundSelected: '#daebfa',
  backgroundSidebarSecondary: 'white',
  backgroundViewJoinOptions: '#F0F3F7',
  backgroundWarning: '#f1ad33',
  borderColorInput: '#D1DBE8',
  boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
  boxShadowSalesforceSearchItem: 'inset 0px -1px 0px rgba(0, 0, 0, 0.05);',
  color: '#1c2025',
  colorDelimiter: 'rgba(0, 0, 0, 0.05)',
  colorError: '#e12d2d',
  colorHighlight: '#0376da',
  colorIcon: '#a4b8d1',
  colorInput: '#1c2025',
  colorLabel: '#1c2025',
  colorLink: '#0376DA',
  colorListItemIcon: '#5e6d7a',
  colorSecondary: '#5e6d7a',
  colorSelected: '#1c2025',
  colorTertiary: 'black'
}
